import { apiRequest } from "@/api";

const state = {
  looks: [],
  look_male: [],
  look_female: [],
  looks_styles: [],
  latest_id: "",
};

function get_styles(obj, state) {
  for (let i = 0; i < obj.style.length; i++) {
    const element = obj.style[i];
    if (!state.looks_styles.includes(element) && element.length) {
      state.looks_styles.push(element);
    }
  }
}

const mutations = {
  SET_LOOKS: (state, { rootState, object }) => {
    console.log(state);
    console.log(rootState);
    console.log(object);
    let id = 0;
    for (var i = 0; object[i]; i++) {
      get_styles(object[i], state);
      if (object[i].gender === "male") {
        state.look_male.push(object[i]);
      } else if (object[i].gender === "female") {
        state.look_female.push(object[i]);
      }
      if (id <= parseInt(object[i].id)) {
        id = parseInt(object[i].id);
        const res = parseInt(object[i].id) + 1;
        state.latest_id = res.toString();
      }
      object[i].selected = false;
      object[i].style_arr =
        object[i].style.length && object[i].style[0].length > 0
          ? object[i].style
          : [];
      object[i].product_ids = object[i].product_ids.map((p) => {
        return rootState.product.products[p] || {};
      });
    }
    state.looks = object;
  },
};

const actions = {
  FETCH_LOOKS: ({ commit, rootState }) => {
    return apiRequest()
      .get("looks/all")
      .then((response) => {
        commit("SET_LOOKS", { rootState, object: response.data.response });
      });
  },
  // eslint-disable-next-line no-empty-pattern
  UPDATE_LOOK: ({}, params) => {
    return apiRequest()
      .post("looks/update", params)
      .then(({ data }) => {
        return data;
      })
      .catch((e) => {
        throw e;
      });
  },
  DELETE_LOOK: ({}, params) => {
    return apiRequest()
      .post("looks/delete", params)
      .then(({ data }) => {
        return data;
      })
      .catch((e) => {
        throw e;
      });
  },
};

export default { state, mutations, actions };
